import type { RouterUseQueryOptions } from '@newfront-insurance/data-layer-client';
import type { SuccessfulResult } from '@newfront-insurance/data-layer-http';
import type { RouterQueryOutput } from '@newfront-insurance/data-layer-server';

import { useAdminTRPC } from '../../../shared/providers/trpc';
import type { SharedRouter } from '../../../shared/trpc/router';

type ProducerSummariesQueryResult = RouterQueryOutput<SharedRouter, 'employees.getProducerSummaries'>;
export type ProducerSummaries = SuccessfulResult<ProducerSummariesQueryResult>;
export type ProducerSummary = ProducerSummaries[number];

/**
 * All producers, without auth roles. Prefer this over `useProducers` for selectors, avatars and
 * name lookups — it skips the per-employee role lookup that `useProducers` pays for. If you need
 * `roles` or `departments`, use `useProducers`.
 */
export function useProducerSummaries(options?: RouterUseQueryOptions<SharedRouter, 'employees.getProducerSummaries'>) {
  const { useQuery } = useAdminTRPC();

  return useQuery(['employees.getProducerSummaries'], options);
}
